/**
 * @generated SignedSource<<67c74e3240d9b4552c12f15cb2e1628c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BrowsePeopleFieldSection$data = {
  readonly errors: ReadonlyArray<{
    readonly message: string | null;
  } | null> | null;
  readonly results: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"IllustrationCard" | "LocationCard">;
  } | null> | null;
  readonly " $fragmentType": "BrowsePeopleFieldSection";
};
export type BrowsePeopleFieldSection$key = {
  readonly " $data"?: BrowsePeopleFieldSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrowsePeopleFieldSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BrowsePeopleFieldSection",
  "selections": [
    {
      "concreteType": "PeopleFieldAggregate",
      "kind": "LinkedField",
      "name": "results",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "LocationCard"
        },
        {
          "kind": "FragmentSpread",
          "name": "IllustrationCard"
        }
      ]
    },
    {
      "concreteType": "PeopleFieldAggregateError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "message"
        }
      ]
    }
  ],
  "type": "PeopleFieldAggregateResponse"
};

(node as any).hash = "8877e10ffc8acc0c818bc530752c5156";

export default node;
